export function downloadExcelFileToBrowser(responseJson, fileName) { 
    var blob = new Blob([s2ab(atob(responseJson))], { type: '' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);

    document.body.appendChild(link);

    link.click();

    link.parentNode.removeChild(link);
}

// taken from https://stackoverflow.com/questions/34993292/how-to-save-xlsx-data-to-file-as-a-blob
// which took it from https://github.com/SheetJS/sheetjs/blob/master/README.md
function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }